import { memo, useMemo } from 'react';

import { ModalCloseButton } from '@air/primitive-modal';

import { useSharePrivateCollectionModal } from '~/components/SharePrivateCollectionModal/SharePrivateCollectionModalContext';

export type EditSharePrivateCollectionModalHeaderProps = {
  onClose: AirModalProps['onClose'];
};

export const EditSharePrivateCollectionModalHeader = memo(({ onClose }: EditSharePrivateCollectionModalHeaderProps) => {
  const { collectionProps } = useSharePrivateCollectionModal();

  const itemsCount = useMemo(
    () =>
      collectionProps.stats
        ? collectionProps.stats.assetCount + collectionProps.stats.fileCount + collectionProps.stats.boardCount
        : undefined,
    [collectionProps.stats],
  );

  return (
    <div className="flex items-center justify-between border-b border-b-grey-5 px-8 py-6">
      <div className="flex flex-col">
        <div className="font-semibold text-24 text-grey-12 leading-8">Manage share link</div>
        {!!itemsCount && <div className="text-16 text-grey-12">{itemsCount} items in this link</div>}
      </div>
      <ModalCloseButton
        className="shrink-0"
        onClick={onClose}
        data-testid="SHARE_PRIVATE_COLLECTION_MODAL_HEADER_CLOSE_BUTTON"
      />
    </div>
  );
});

EditSharePrivateCollectionModalHeader.displayName = 'EditSharePrivateCollectionModalHeader';
